/**
 * Collapses repeated slashes in the pathname (e.g. "//single-sign-on" -> "/single-sign-on").
 * Links copied from a JSON response with escaped slashes ("https:\/\/host\/single-sign-on")
 * are read by browsers as "https://host//single-sign-on", which no route matches.
 */
export const getNormalizedPath = (location: Pick<Location, "pathname" | "search" | "hash">): string | null => {
  const pathname = location.pathname.replace(/\/{2,}/g, "/");

  if (pathname === location.pathname) {
    return null;
  }

  return pathname + location.search + location.hash;
};

export const normalizePathSlashes = () => {
  const normalizedPath = getNormalizedPath(window.location);

  if (normalizedPath) {
    window.history.replaceState(window.history.state, "", normalizedPath);
  }
};
